export default {
  faq: 'Perguntas Frequentes',
  filters: 'Filtros',
  forgot_my_password: 'Esqueci minha senha',
  menu: 'Menu',
  need_help: 'Precisa de ajuda?',
  no_data_grid: 'Não há dados disponíveis',
  reserved_rights: '© Todos os Direitos Reservados - SESAB',
  manually: 'Permite a criação do paciente manualmente',
  data_sus:
    'Digite o CPF ou CNS do paciente para buscar na base de dados do DataSUS',
  search_patient_in_data_sus: 'Buscar paciente no DataSUS',
  searchInDataSUS: 'Buscar paciente no DataSUS',
  select_one_option: 'Selecione uma opção',
  no_results: 'Nenhum resultado encontrado',
  try_search:
    'Com base nos dados fornecidos não foi possível encontrar o paciente no DataSUS',
  fill_manually: 'Preencher manualmente',
  sync_data: 'Sincronizando dados',
  sync_wait: 'Aguarde enquanto sincronizamos as informações',
  patient_found: 'Paciente encontrado!',
  patient_found_continue:
    'Clique em continuar para exibir os dados encontrados',
  unavailable_unity_procedure:
    'Procedimento e/ou Tipo de procedimento não está disponível para a unidade do solicitante',
  list_solicitations: 'Lista de solicitações',
  list_unities: 'Lista de unidades',
  schedule: 'Agenda',
  attention: 'Atenção',
  vehicle_cer:
    'Caso necessite que o transporte seja disponibilizado pela CER fazer solicitação de ambulância UTI pelo SUREM, com 24 horas de antecedência da data do procedimento',
  delete_holiday: 'Deletar feriado',
  protocol_binded: 'Protocolo vinculado',
  to_view: 'Visualizar',
  download: 'Baixar',
  conitnue_or_change_unity:
    'Gostaria de permanecer na unidade atual ou escolher uma diferente?',
  login_in_progress: 'Seu login está em andamento',
  please_wait_moment: 'Por favor, aguarde um momento',
  login_completed_successfully: 'Login concluído com sucesso!',
  wait_while_redirecting: 'Aguarde enquanto redirecionamos você',
  login_error: 'Ops! Algo deu errado ao tentar fazer o login',
  login_issue:
    'Lamentamos, mas enfrentamos um problema durante o seu login. Por favor, tente novamente. Se o problema persistir, entre em contato conosco',
  search_account_data: 'Obtendo informações da conta',
  search_professional: 'Buscando profissional',
  no_unities: 'Não há unidades vinculadas à conta do usuário',
  add_unity: 'Clique no botão abaixo para realizar a adição',
  only_one_profile_allowed_during_account_creation:
    'Durante o processo de criação de conta, apenas um perfil é permitido',
  select_unit_and_profile: 'Selecione a unidade e o perfil desejado',
  account_linked_units: 'Unidades vinculadas a conta',
  confirm_completion_password_required:
    ' Para concluir a confirmação, é necessário fornecer a senha utilizada no login',
  pending_confirmation: 'Confirmação pendente',
  selected_data: 'Dados selecionados',
  unit_profile_modification_info:
    'Informações sobre a modificação de unidade/perfil',
  selected_profile: 'Perfil selecionado',
  link_to_correios: 'Acessar site dos correios',
  pending_solicitaiton_on_lu: 'Solicitação pendente no Lista Única',
  continue_request: 'Gostaria de dar continuidade a essa solicitação?',
  pending_solicitation_in_lu:
    'Uma solicitação pendente de agendamento foi encontrada no Sistema Lista Única para o Paciente selecionado.',
  select_solicitation_to_continue:
    'Selecione a solicitação que gostaria de dar continuidade',
  procedure_not_associated:
    'O procedimento atual não está associado a nenhuma unidade',
  no_records_selected: 'Nenhum registro selecionado',
  selected_procedure: 'Procedimento selecionado',
  selected_option: 'Opção selecionada',
  outpatient: 'Ambulatorial Inicial',
  ppp: 'Exames de Imagem',
  unacon: 'Oncologia (UNACON/CACON)',
  egress: 'Ambulatorial Egresso',
  protocol_error:
    'Encontramos divergencias entre os dados do paciente e o protocolo cadastrado',
  protocol_divergent: 'Protocolo divergente',
  genders_allowed: 'Sexo(s) permitido(s)',
  about_to_remove_bind_procedure:
    'Você está prestes a remover o procedimento vinculado à unidade',
  are_you_want_to_confirm_action:
    'Tem certeza de que deseja confirmar essa ação?',
  diagnostic: 'Paciente com Diagnóstico de Câncer',
  suspicion: 'Paciente com Suspeita de Câncer',
  about_to_remove_professional_occupation:
    'Você está prestes a remover a ocupação/sub-ocupação vinculada ao profissional',
  please_type_professional_cpf:
    'Por favor, preencha o campo de CPF para verificar se o profissional existe em nossa base de dados',
  professional_found_in_database:
    'Com base na busca realizada pelo CPF fornecido, foi possível localizar um profissional correspondente aos critérios de pesquisa',
  professional_found: 'Profissional encontrado',
  description_to_continue:
    'Para continuar, será necessário descrever o motivo abaixo',
  assessment_available: 'Avaliação disponível',
  status_changed_to: 'Status alterado para',
  service_unity: 'Unidade de atendimento',
  details: 'Detalhes',
  list_judicial_decisions: 'Lista de decisões judiciais',
  register_judicial_decision: 'Cadastrar decisão judicial',
  update_judicial_decision: 'Atualizar decisão judicial',
  add_a_file: 'Insira um arquivo',
  select_patients: 'Selecione os pacientes',
  add_a_procedure: 'Insira um procedimento',
  is_loading: 'Aguarde... Carregando dados',
  select_solicitations: 'Selecione as solicitações',
  profile_unity_or_not_relevant:
    'Solicitação fora do perfil da Unidade, ou Não Pertinente?',
  remove_unity_bind: 'Remover unidade vinculada',
  confirm_remove_unity_bind:
    'Deseja remover a unidade vinculada a essa solicitação?',
  oncology_alert: 'Obrigatório a leitura do Protocolo de Acesso em anexo',
  elective_surgeries: 'Cirurgias eletivas',
  accreditation: 'Credenciamento',
  elective_surgeries_accreditation: 'Cirurgias eletivas > Credenciamento ',
  add_accreditation: 'Cadastrar credenciamento',
  update_accreditation: 'Atualizar credenciamento',
  duplicate_accreditation: 'Duplicar credenciamento',
  add_procedure: 'Cadastrar procedimento',
  update_procedure: 'Atualizar procedimento',
  protocol_min_max_age: 'Idade máxima: 130 anos, 11 meses e 31 dias',
  elective_surgeries_binded_procedure:
    'Cirurgias eletivas > Procedimento vinculado',
  bind_procedure: 'Vincular procedimento',
  elective_surgery: 'Consulta Pré-cirugica',
  add_or_remove_procedure_reference:
    'Você deseja {action} o procedimento como referência da unidade?',
  remove_reference: 'Deseja remover a referência dessa solicitação?',
  localization: 'Localização',
  fill_lat_lon: 'Por favor, preencha os dados de latitude e longitude',
  select_cid_for_inclusion_in_solicitation:
    'Selecione o CID para inclui-lo na solicitação',
  solicitaiton_details: 'Detalhes da solicitação',
  diagnosis_not_confirmed:
    'Ao confirmar, a solicitação será definida com o status de "Diagnóstico não confirmado"',
  treatment_started:
    'Ao confirmar, a solicitação será definida com o status de "Tratamento iniciado"',
  treatment_not_started:
    'Ao confirmar, a solicitação será definida com o status de "Tratamento não iniciado"',
  solicitation_status: 'Status da solicitação',
  registration_and_contact_data: 'Dados cadastrais e contatos da unidade',
  physical_location_and_territorial_linkage:
    'Localização física e vinculação territorial',
  administrative_classification_and_georeferencing:
    'Classificação administrativa e georreferenciamento',
  enabled_resources: 'Recursos habilitados para esta unidade',
  imaging_exam_requests: 'Permite abrir solicitações de exames de imagem',
  outpatient_requests: 'Permite abrir solicitações ambulatoriais',
  outpatient_post_discharge_requests:
    'Permite abrir solicitações ambulatoriais para pacientes egressos (pós-alta)',
  oncology_requests: 'Permite abrir solicitações de oncologia',
  elective_surgery_requests: 'Permite abrir solicitações de cirurgias eletivas',
  synchronize_with_aghuse: 'Sincroniza dados com o sistema hospitalar AGHUse',
};
